import Link from '@mui/material/Link';
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import '../style/RecaptchaDisclosure.css';

const PRIVACY_URL = 'https://policies.google.com/privacy';
const TERMS_URL = 'https://policies.google.com/terms';

const RecaptchaDisclosure = () => {
    const { t } = useTranslation();
    const { theme } = useSelector((store) => store.theme);

    return (
        <p className="recaptcha-disclosure" style={{ color: theme.footerTextColor }}>
            <Trans
                i18nKey="recaptcha_disclosure"
                t={t}
                components={{
                    privacy: <Link href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" color="inherit" underline="always" />,
                    terms: <Link href={TERMS_URL} target="_blank" rel="noopener noreferrer" color="inherit" underline="always" />,
                }}
            />
        </p>
    );
};

export default RecaptchaDisclosure;
